module.exports = __webpack_public_path__ + "assets/img/small_generic_icon.bf3e7435.svg";